import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Button, Column, Form, Input, Modal, Padding } from '../../../..'

const { FormGroup, FormHeader } = Form
const status = [
    { name: 'Online', value: 'Online' },
    { name: 'Offline', value: 'Offline' },
]

class FilterForm extends PureComponent {
    static propTypes = {
        form: PropTypes.shape({
            selectedGroups: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
            selectedCountries: PropTypes.arrayOf(PropTypes.string),
            selectedChains: PropTypes.arrayOf(PropTypes.string),
            deviceGroups: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    value: PropTypes.string,
                })
            ).isRequired,
            countries: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    value: PropTypes.string,
                })
            ).isRequired,
            chains: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    value: PropTypes.string,
                })
            ).isRequired,
        }),
        innerRef: PropTypes.shape({}),
        isOpen: PropTypes.bool,
        onChangeForm: PropTypes.func,
        onClickCancel: PropTypes.func,
        onClickSubmit: PropTypes.func,
        fetchingData: PropTypes.bool,
        t: PropTypes.func.isRequired,
        onlyByDevice: PropTypes.bool,
        clearFilters: PropTypes.func,
        isActiveFilters: PropTypes.bool,
    }

    static defaultProps = {
        innerRef: null,
        isOpen: false,
        form: {
            mode: 'searchByDevice',
            deviceGroups: [],
            selectedGroups: [],
        },
        onChangeForm: () => null,
        onClickCancel: () => null,
        onClickSubmit: () => null,
        fetchingData: false,
        onlyByDevice: false,
        clearFilters: null,
        isActiveFilters: false,
    }

    renderCountryForm = () => {
        const { form, t, onChangeForm } = this.props
        const { countries, selectedCountries } = form

        return (
            <FormGroup title={t('Countries')} scrollable>
                <Input
                    id="selectedCountries"
                    name="selectedCountries"
                    type="multiple"
                    onChange={onChangeForm}
                    value={selectedCountries}
                    values={countries}
                    column
                />
            </FormGroup>
        )
    }

    renderChainsForm = () => {
        const { form, t, onChangeForm } = this.props
        const { chains, selectedChains } = form

        return (
            <FormGroup title={t('Chains')} scrollable>
                <Input id="selectedChains" name="selectedChains" type="multiple" onChange={onChangeForm} value={selectedChains} values={chains} column />
            </FormGroup>
        )
    }

    renderDeviceGroupsForm = () => {
        const { form, t, onChangeForm } = this.props
        const { deviceGroups, selectedGroups } = form
        return (
            <FormGroup title={t('Device groups')} scrollable>
                <Input id="selectedGroups" name="selectedGroups" type="multiple" onChange={onChangeForm} value={selectedGroups} values={deviceGroups} column />
            </FormGroup>
        )
    }

    renderOnlineOfflineForm = () => {
        const { form, t, onChangeForm } = this.props
        const { selectedStatus } = form

        return (
            <FormGroup title={t('Status')} scrollable>
                <Input id="selectedStatus" name="selectedStatus" type="multiple" onChange={onChangeForm} value={selectedStatus} values={status} column />
            </FormGroup>
        )
    }

    renderMigrationForm = () => {
        const { form, t, onChangeForm } = this.props
        const { migrated } = form

        return (
            <FormGroup title={t('devices-migration-status')} scrollable>
                <Input
                    id="migrated"
                    name="migrated"
                    type="multiple"
                    onChange={onChangeForm}
                    value={[migrated]}
                    values={[
                        { name: t('Migrated'), value: true },
                        { name: t('Not Migrated'), value: false },
                    ]}
                    onlyOne
                />
            </FormGroup>
        )
    }

    renderEmptyStoresForm = () => {
        const { form, t, onChangeForm } = this.props
        const { showEmptyStores } = form

        return (
            <FormGroup title={t('Show Empty Stores')} scrollable>
                <Input
                    id="showEmptyStores"
                    name="showEmptyStores"
                    type="multiple"
                    onChange={onChangeForm}
                    value={[showEmptyStores]}
                    values={[
                        { name: t('Yes'), value: true },
                        { name: t('No'), value: false },
                    ]}
                    onlyOne
                />
            </FormGroup>
        )
    }

    render() {
        const { isOpen, onClickCancel, onClickSubmit, form, fetchingData, t, onlyByDevice, isActiveFilters, clearFilters } = this.props
        const { deviceGroups } = form
        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} minWidth="419px" scrollable>
                <Form>
                    <FormHeader>
                        <Padding right bottom size="sm">
                            <Column>{onlyByDevice ? t('filters-device') : t('filters-store')}</Column>
                        </Padding>
                    </FormHeader>
                    {!fetchingData && !onlyByDevice && this.renderEmptyStoresForm()}
                    {!fetchingData && !onlyByDevice && this.renderCountryForm()}
                    {!fetchingData && !onlyByDevice && this.renderChainsForm()}
                    {!fetchingData && deviceGroups && onlyByDevice && this.renderDeviceGroupsForm()}
                    {!fetchingData && deviceGroups && onlyByDevice && this.renderOnlineOfflineForm()}
                    {!fetchingData && deviceGroups && onlyByDevice && this.renderMigrationForm()}
                    {!fetchingData && deviceGroups && onlyByDevice && this.renderChainsForm()}
                    <div className="modal-bottom">
                        <FormGroup>
                            <Column right width="100%">
                                <Button theme="secondary" onClick={onClickCancel} size="sm">
                                    {t('Cancel')}
                                </Button>
                                {isActiveFilters && !fetchingData && (
                                    <Button
                                        theme="lightDanger"
                                        onClick={() => {
                                            onClickCancel()
                                            clearFilters()
                                        }}
                                        size="sm"
                                        radius="5"
                                    >
                                        {t('Clear filters')}
                                    </Button>
                                )}
                                <Button onClick={onClickSubmit} size="sm" theme={fetchingData ? 'loading' : 'forestGreen'} enabled={!fetchingData}>
                                    {fetchingData ? '...' : t('Filter')}
                                </Button>
                            </Column>
                        </FormGroup>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default withTranslation()(FilterForm)
